module.exports = __webpack_public_path__ + "img/015.c277aaed.jpg";